<template>
  <vx-card
    :title="event.title"
    title-color="primary"
    :subtitle="formatDate(event.startdate)">
    <vs-row
      vs-align="center"
      vs-type="flex" vs-justify="end" vs-w="12">
      <vs-button
        @click="showDetailsPopUp=true"
        color="success"
        type="filled"
        icon-pack="feather"
        class="mr-2"
        icon="icon-edit"/>
      <vs-button
        @click="openAlert('danger')"
        color="danger"
        type="filled"
        icon-pack="feather"
        icon="icon-trash" v-if="event.reservations.length === 0"/>
    </vs-row>
    <div class="flex-1">
      <IconTitleItem icon-name="event" icon-color="primary" text-color="gray" :title="formatDate(event.startdate)"/>
      <IconTitleItem icon-name="money" icon-color="primary" text-color="gray" :title="getFormattedPrices(event.price_list)"/>
      <IconTitleItem icon-name="directions_car" icon-color="primary" text-color="gray" :title="getFormattedPriceTexts(event.price_list)"/>
      <IconTitleItem icon-name="room" icon-color="primary" text-color="gray" :title="event.eventlocation.title"/>
      <IconTitleItem icon-name="group" icon-color="primary" text-color="gray" :title="event.availableplaces.toString()"/>
      <IconTitleItem icon-name="booking" icon-color="primary" text-color="gray" :title="reservations.length.toString()"/>
    </div>
    <vs-row
      vs-type="flex"
      class="pt-2" vs-justify="start">
<!--      <a :href="'https://api.flohmarktkoenig.ch/v1/admin/event-reservation/' + event.id + '/get-reservations-as-csv'" target="_blank">Buchungen exportieren</a>-->
<!--      <a :href="'https://dev-api.flohmarktkoenig.ch/v1/admin/event-reservation/' + event.id + '/get-reservations-as-csv'" target="_blank">Buchungen exportieren</a>-->
      <a :href=" baseUrl + '/v1/admin/event-reservation/' + event.id + '/get-reservations-as-csv'" target="_blank">Buchungen exportieren</a>
    </vs-row>
    <vs-row
      vs-type="flex"
      class="pt-2" vs-justify="end">
      <vs-button @click="goToEventReservation(event.id)" color="primary" type="filled">Buchungen</vs-button>
    </vs-row>
    <!--    Event pop up-->
    <vx-modal :isFullScreen=true title="neues flohmarkt" :active.sync="showDetailsPopUp" v-if="showDetailsPopUp" detach>
      <vs-row vs-type="flex" vs-align="center" vs-w="12">
        <vs-row vs-type="flex" vs-align="center" vs-w="12">
          <vs-input class="inputx mb-3" style="width: 100%;" placeholder="Titel" v-model="eventTitle"/>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" vs-align="center" class="pb-3">
          <flat-pickr :config="configDateTimePicker" style="width: 30%;" v-model="startDate" placeholder="Startdatum" disabled/>
          <span>bis</span>
          <flat-pickr :config="configDateTimePicker" style="width: 30%;" v-model="endDate" placeholder="Enddatum" disabled/>
        </vs-row>


        <vs-row vs-type="flex" vs-justify="space-between" vs-align="center" class="pb-3">
          <vs-input class="inputx mb-3" style="width: 50%;" placeholder="Text" type="text"
                    v-model="price_car_text"/>
          <vs-input class="inputx mb-3" style="width: 40%;" placeholder="Preis pro platz" type="number"
                    v-model="priceperplace_car"/>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" vs-align="center" class="pb-3">
          <vs-input class="inputx mb-3" style="width: 50%;" placeholder="Text" type="text"
                    v-model="price_car_trailer_text"/>
          <vs-input class="inputx mb-3 ml-3" style="width: 40%;" placeholder="Preis pro platz"
                    type="number"
                    v-model="priceperplace_car_trailer"/>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" vs-align="center" class="pb-3">
          <vs-input class="inputx mb-3" style="width: 50%;" placeholder="Text" type="text"
                    v-model="price_bus_text"/>
          <vs-input class="inputx mb-3 ml-3" style="width: 40%;" placeholder="Preis pro platz"
                    type="number"
                    v-model="priceperplace_bus"/>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="space-between" vs-align="center" class="pb-3">
          <vs-input class="inputx mb-3" style="width: 50%;" placeholder="Text" type="text"
                    v-model="price_bus_2_text"/>
          <vs-input class="inputx mb-3 ml-3" style="width: 40%;" placeholder="Preis pro platz"
                    type="number"
                    v-model="priceperplace_bus_2"/>
        </vs-row>

        <vs-row>
          <vs-input class="inputx mb-3" style="width: 100%;" placeholder="verfügbar plätze" v-model="places" :disabled="this.event.hasnums === 1" />
        </vs-row>
        <vs-row>
          <quill-editor style="width: 100%;" v-model="content" placeholder="Marktdetails"></quill-editor>
        </vs-row>
        <vs-row vs-type="flex" class="pt-24" vs-w="12" style="z-index: 9999">
          <vs-checkbox v-model="isActive">Aktiv</vs-checkbox>
        </vs-row>
        <vs-row vs-type="flex" class="pt-24" vs-w="12" style="z-index: 9999" v-if="event.hasnums">
          <vs-row vs-type="flex" vs-justify="start" vs-w="12">
            <p>Wird einen Nummer markiert, ist sie besetzt</p><br>
          </vs-row>
          <vs-checkbox
            class="mr-5 pt-2"
            :class="{ 'special-color': unreservedBusyNums.includes(n.nr) }"
            style="width: 50px"
            v-for="n in nums"
            :key="n.nr"
            v-model="n.busy">
            {{ n.nr }}
          </vs-checkbox>
        </vs-row>
        <vs-row vs-type="flex" vs-justify="end" class="pt-24" vs-w="12">
          <vs-button @click="showConfirmPopUp=true" color="primary" type="filled">Aktualisieren</vs-button>
        </vs-row>
      </vs-row>
      <vx-modal title="Sind Sie sicher?" v-if="showConfirmPopUp" :active.sync="showConfirmPopUp">
        <p>Sind Sie sicher, dass Sie diesen Flohmarkt aktualisieren wollen?</p>
        <vs-row vs-type="flex" vs-justify="end" class="pt-12" vs-w="12">
          <vs-button @click="onConfirmPress" color="success" type="filled">Ja</vs-button>
        </vs-row>
      </vx-modal>
    </vx-modal>
    <!--    Event pop up-->
  </vx-card>
</template>

<script>
  import IconTitleItem from "./IconTitleItem";
  import flatPickr from 'vue-flatpickr-component';
  import {quillEditor} from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import {mapActions, mapGetters} from "vuex";

  export default {
    name: "EventCard",
    components: {
      IconTitleItem,
      flatPickr,
      quillEditor
    },

    data() {
      return {
        baseUrl: process.env.VUE_APP_API_BASE_URL,
        showDetailsPopUp: false,
        showConfirmPopUp: false,
        // inputs
        eventTitle: this.event.title,
        isActive: this.event.isactive,
        startDate: new Date(this.event.startdate + "T" + this.event.starttime),
        endDate: new Date(this.event.enddate + "T" + this.event.endtime),
        priceperplace_car: this.event.priceperplace_car?this.event.priceperplace_car:parseInt(this.event.priceperplace),
        priceperplace_car_trailer: this.event.priceperplace_car_trailer,
        priceperplace_bus: this.event.priceperplace_bus,
        priceperplace_bus_2: this.event.priceperplace_bus_2,
        price_car_text: this.event.price_car_text,
        price_car_trailer_text: this.event.price_car_trailer_text,
        price_bus_text: this.event.price_bus_text,
        price_bus_2_text: this.event.price_bus_2_text,
        places: this.event.availableplaces,
        content: this.event.description,
        nums: JSON.parse(this.event.nums, (key, value) => {
          if (typeof value === 'boolean') {
            return value ? 1 : 0;
          }
          return value;
        }),
        reservations: this.event.reservations,
        configDateTimePicker: {
          enableTime: true,
          dateFormat: 'd-m-Y H:i'
        }
      }
    },
    computed: {
      unreservedBusyNums() {
        const busyNums = this.nums
          .filter(num => num.busy === 1)
          .map(num => num.nr);

        const reservedNums = this.reservations
          .flatMap(reservation => JSON.parse(reservation.nums))
          .flat();

        return busyNums.filter(num => !reservedNums.includes(num));
      },
    },
    props: {
      event: {
        type: Object
      }
    },
    created() {
    },
    methods: {
      ...mapActions(['deleteEvent']),
      ...mapActions(['updateEvent']),
      ...mapActions(['fetchEvents']),
      goToEventReservation(id){
        this.$router.push({name: 'reservations',params: { type: 'event', id: id }})
      },
      getFormattedPriceTexts(priceList){
        let priceTexts = priceList.map(el=>el.text)
        // Check if all texts are different than empty and null
        if(priceTexts.every(el=>el!=="" && el!==null)){
          return priceTexts.join(", ")
        }
        return 'Standard';

      },
      getFormattedPrices(priceList){
        let prices= priceList.map(el=>el.priceperplace)
        return prices.join(", ")
      },
      formatDate(dateString) {
        let date = new Date(dateString)
        return date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
      },
      openAlert(color) {
        this.colorAlert = color
        this.$vs.dialog({
          color: this.colorAlert,
          title: `Sind Sie sicher?`,
          text: color === 'danger' ? 'Sind Sie sicher, dass Sie diesen Flohmarkt löschen möchten?' : 'Sind Sie sicher, dass Sie die Reservierung annehmen möchten?',
          accept: this.acceptAlert,
          acceptText: 'JA'
        })
      },
      acceptAlert() {
        this.deleteEvent(this.event.id).then(() => {
            this.fetchEvents().then(_ => {
              if(this.colorAlert != 'danger'){
                this.$toast.success('Reservierung akzeptiert')
              }else{
                this.$toast.error('Flohmarkt gelöschte')
              }
            })
            
            
        })
      },
      onConfirmPress() {
        const nums = JSON.stringify(this.nums, (key, value) => {
        if (typeof value === 'boolean') {
            return value ? 1 : 0; 
          }
          return value;
        });
        let eventToUpdate = {
          id: this.event.id,
          title: this.eventTitle,
          isactive: this.isActive,
          priceperplace_car: this.priceperplace_car,
          priceperplace_car_trailer: this.priceperplace_car_trailer,
          priceperplace_bus: this.priceperplace_bus,
          priceperplace_bus_2: this.priceperplace_bus_2,
          price_car_text: this.price_car_text,
          price_car_trailer_text: this.price_car_trailer_text,
          price_bus_text: this.price_bus_text,
          price_bus_2_text: this.price_bus_2_text,
          availableplaces: this.places,
          description: this.content,
          nums: nums,
        }
        this.updateEvent(eventToUpdate).then(() => {
          this.fetchEvents().then(_ => {
            this.showConfirmPopUp = false
            this.showDetailsPopUp = false
            this.$toast.success('Flohmarkt aktualisiert')
          })
        })
      }
    }
  }
</script>

<style>
.special-color {
  color: orangered !important; 
  font-weight: bold !important;
}
</style>
